import AsyncFormComponent from "./async-form.component";
import Notification from '../../../general/js/notification';
import gtm from '../../../general/js/gtm';
import template from '../html/download-file-notification-template.hbs';

export default class DownloadFilePopupFormComponent extends AsyncFormComponent {

    constructor() {
        super(...arguments);

        this.downloadTrackingInfo = null;
        this.redirectTimeout = null;
        this.onDownloadButtonClick = this.onDownloadButtonClick.bind(this);
    }

    onSuccess(result) {
        this.cleanUp();

        let notification;
        let template = this.getTemplate();
        notification = Notification.create(template(result));
        notification.open();

        if (result.downloadUrl) {
            this.downloadButton = notification.getElement().querySelector('.js-download-file-button');
            if (this.downloadButton) {
                this.downloadButton.addEventListener('click', this.onDownloadButtonClick);
            }
            this.downloadTrackingInfo = result.downloadTrackingInfo;
            this.redirectTimeout = setTimeout(() => {
                this.autoDownload(result.downloadUrl);
            }, 2000);

            // Main save button
            $(".lot-nav__buttons .lot-nav__btn button").addClass("is-saved");
            $(".lot-nav__buttons .favorites-button__text").text("saved");

            $(".lots-list__inner a.lots-list__item--active .lot-item__favorites-button button").addClass("is-saved");
            $(".lots-list__inner a.lots-list__item--active .lot-item__favorites-button span.favorites-button__text").text("saved");
        }
    }

    handleTracking() {
        if (this.downloadTrackingInfo) {
            gtm.push(this.downloadTrackingInfo);
            this.downloadTrackingInfo = null;
        }
    }

    autoDownload(url) {
        this.redirectTimeout = null;
        if (this.downloadButton) {
            this.downloadButton.removeEventListener('click', this.onDownloadButtonClick);
        }
        this.handleTracking();
        window.location.href = url;
    }

    onDownloadButtonClick(e) {
        this.handleTracking();
        this.cleanUp();
    }

    getTemplate() {
        return template;
    }

    cleanUp() {
        if (this.downloadButton) {
            this.downloadButton.removeEventListener('click', this.onDownloadButtonClick);
        }
        if (this.redirectTimeout) {
            clearTimeout(this.redirectTimeout);
            this.redirectTimeout = null;
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/form/js/download-file-popup-form.component.js